export const identityMatrix = [1, 0, 0, 1, 0, 0];
